var map = {
	"./2024-02-28 1.0.4.pdf": 23909,
	"./2024-03-20 1.1.16.pdf": 34340,
	"./2024-03-20 1.2.37.pdf": 95960,
	"./2024-03-20 1.2.38.pdf": 49929,
	"./2024-03-20 1.2.39.pdf": 92439,
	"./2024-06-10 1.3.47.pdf": 55021,
	"./2024-07-10 1.4.27.pdf": 65437,
	"./2024-08-23 1.5.64.pdf": 62542,
	"./2024-09-25 1.6.x.pdf": 63175,
	"./2026-04-23 1.9.6.pdf": 5189,
	"./2026-05-15 1.9.7.pdf": 89653,
	"./2026-07-02 1.10.1.pdf": 32898,
	"./2026-09-04 1.11.0.pdf": 69329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65594;